import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
// 引入各个语言配置文件
import en from './lang/en';
import es from './lang/es';
import pt from './lang/pt';
// 创建vue-i18n实例i18n
const i18n = new VueI18n({
    // 设置默认语言
    locale: localStorage.getItem('localeLang') || 'en',  // 语言标识
    // 添加多语言（每一个语言标示对应一个语言文件）
    messages: {
        en,
        es,
        pt
    }
})
// 暴露i18n
export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js